import { Formik, useFormik } from 'formik';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { blankIdiqReport, blankIdiqReportLogin, blankReportSubmitReport, getIdiqReport, getIdiqReportLogin, setReportUploaded, submitReportContent } from '../../redux/slices/ReportSlice';

import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import NotyfContext from '../../contexts/NotyfContext';
import { Alert, Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import { callUserActvity, fetchNotification, setNotifcationBedge } from '../../redux/slices/CommonSlice';
import LoaderTest from './LoaderTest';
import Dbot from './delivery-bot.gif';

const ReportUpload = props => {
  const [submitReportStatus, setSubmitReportStatus] = useState('');

  const { id, isNagative, reportData, setReportData, reportDataRef, isLogin, closeModel, gotoDashboard } = props;
  const [showLoader, setShowLoader] = useState(false);

  const navigate = useNavigate();
  const notyf = useContext(NotyfContext);
  const reportTypeInnerRef = useRef('');

  const [showGetReportModal, setShowGetReportModal] = useState(false);
  const [reportModalBody, setReportModelBody] = useState('');
  const [buttonSpinner, setButtonSpinner] = useState(false);
  const [error, setError] = useState('');
  const [iFrameUrl, setiFrameUrl] = useState( reportData.report_type === '5' ? 'https://ebook.aflip.in/Disputelyidiq' : 'https://ebook.aflip.in/disputelysmartcredit');
  const dispatch = useDispatch();
  const handleReportFileChange = async e => {
    if (e.target.files) {
      let file = e.target.files[0];
      let obj = {
        id: id,
        file: file,
      };
      setShowLoader(true);
      await dispatch(getIdiqReport(obj));
    }
  };

  const handleReportSubmit = async () => {
    const resultAction = await dispatch(submitReportContent(reportData));
    setSubmitReportStatus(resultAction.meta.requestStatus);
    dispatch(fetchNotification());
    dispatch(setNotifcationBedge(true));
    setShowLoader(false);
  };
  const closeReportModal = () => {
    let reportDataOri = { ...reportData };
    reportDataOri.report_type = '';
    reportDataOri.report_content = '';
    setReportData(reportDataOri);
    reportDataRef.current = {
      report_type: '',
      report_content: '',
    };
    setShowGetReportModal(false);
  };

  return (
    <React.Fragment>
      {showLoader && <LoaderTest image={iFrameUrl} width='600px' />}

      <Formik
        enableReinitialize={true}
        initialValues={{
          username: '',
          password: '',
          ssn: '',
          report_type: reportData.report_type,
        }}
        validationSchema = {Yup.object().shape({
          username: Yup.string().max(255).required('Username is required'),
          password: Yup.string().max(255).required('Password is required'),
          ssn: Yup.string().when('report_type', {
            is: 5,
            then: Yup.string()
              .max(4)
              .required('Last 4 of Social Security number is required')
              .matches(/(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/, 'Last 4 of Social Security Must be number'),
          }),
        })}
        onSubmit={async (values, { setErrors, setStatus, setSubmitting, resetForm }) => {
          setShowLoader(true);
          try {
            // setButtonSpinner(true);
            let obj = {
              id: id,
              report_type: values.report_type,
              username: values.username,
              password: values.password,
              ssn: values.ssn,
            };
            const res = await dispatch(getIdiqReportLogin(obj)).unwrap();
            if(res.error === 1){
              setErrors({ submit: res?.data?.message || "Something went wrong, kindly try again" });
              setError(res?.data?.message || "Something went wrong, kindly try again")
              notyf.open({
                type: 'danger',
                message: res?.data?.message || "Something went wrong, kindly try again",
                duration: '3000',
                ripple: false,
                dismissible: false,
                position: {
                  x: 'right',
                  y: 'top',
                },
              });
            }else{
              navigate(`/report-audit`, {replace: true});
            }
          } catch (error) {
            const message = error.message || 'Something went wrong, kindly try again';
            setError(message);
            notyf.open({
              type: 'danger',
              message: message,
              duration: '3000',
              ripple: false,
              dismissible: false,
              position: {
                x: 'right',
                y: 'top',
              },
            });
            setStatus({ success: false });
            setErrors({ submit: message });
          }finally{
            setSubmitting(false);
            setShowLoader(false);
          }

        }}>
        {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values, resetForm }) => {

          return (
            <Form onSubmit={handleSubmit}>
              <h3 className='text-center'>Login to your provider</h3>

              {error && <Alert variant='danger'>{error}</Alert>}

              <Form.Group>
                <Form.Label className='text-light-gray'>Provider</Form.Label>
                <Form.Select
                  aria-label='Choose Your Provider'
                  className='mb-3'
                  size='lg'
                  name='report_type'
                  id='report_type'
                  value={values.report_type}
                  isInvalid={Boolean(touched.report_type && errors.report_type)}
                  onBlur={handleBlur}
                  onChange={e => {
                    handleChange(e);
                    setiFrameUrl(e.target.value === '5' ? 'https://ebook.aflip.in/Disputelyidiq' : 'https://ebook.aflip.in/disputelysmartcredit');
                  }}>
                  <option value=''>Choose Your Provider</option>
                  {isLogin ? (
                    <>
                      <option value='5'>Identity IQ</option>
                      <option value='6'>Smart Credit</option>
                      {/* <option value='7'>TrulyID</option> */}
                    </>
                  ) : (
                    <>
                      <option value='1'>Identity IQ HTML</option>
                      <option value='2'>MFS&F/SMARTCREDIT HTML</option>
                      <option value='12'>Identity IQ PDF</option>
                    </>
                  )}
                </Form.Select>
                {!!touched.report_type && <Form.Control.Feedback type='invalid'>{errors.report_type}</Form.Control.Feedback>}
              </Form.Group>

              {values.report_type === '12' && (
                <Form.Group className='mb-3'>
                  <Form.Label className='text-light-gray'>Report File</Form.Label>
                  <Form.Control type='file' name='report_file' id='report_file' onChange={e => handleReportFileChange(e)} />
                </Form.Group>
              )}
              {(values.report_type === '5' || values.report_type === '6' || values.report_type === '7') && (
                <div className='mb-3'>
                  <Form.Control type='hidden' name='reportType5' id='reportType5' ref={reportTypeInnerRef} value={values.report_type} />

                  <Row>
                    <Col lg={12} className='mb-3'>
                      <Form.Group>
                        <Form.Label className='text-light-gray'>Username/Email</Form.Label>
                        <Form.Control type='text' name='username' id='username' placeholder='Username/Email' onChange={handleChange} onBlur={handleBlur} value={values.username} isInvalid={Boolean(touched.username && errors.username)} />
                        {!!touched.username && <Form.Control.Feedback type='invalid'>{errors.username}</Form.Control.Feedback>}
                      </Form.Group>
                    </Col>
                    <Col lg={12} className='mb-3'>
                      <Form.Group>
                        <Form.Label className='text-light-gray'>Password</Form.Label>
                        <Form.Control type='password' name='password' id='password' placeholder='Password' onChange={handleChange} onBlur={handleBlur} value={values.password} isInvalid={Boolean(touched.password && errors.password)} />
                        {!!touched.password && <Form.Control.Feedback type='invalid'>{errors.password}</Form.Control.Feedback>}
                      </Form.Group>
                    </Col>
                    {values.report_type === '5' ? (
                      <Col lg={12} className='mb-3'>
                        <Form.Group>
                          <Form.Label className='text-light-gray'>Last 4 of Social Security Number</Form.Label>
                          <Form.Control type='password' autoComplete='off' name='ssn' id='ssn' placeholder='Last 4 of Social Security Number' maxLength={4} onChange={handleChange} onBlur={handleBlur} value={values.ssn} isInvalid={Boolean(touched.ssn && errors.ssn)} />
                          {!!touched.ssn && <Form.Control.Feedback type='invalid'>{errors.ssn}</Form.Control.Feedback>}
                        </Form.Group>
                      </Col>
                    ) : null}
                    <Col lg={12} style={{ marginTop: '31px' }}>
                      <Button
                        className='w-100'
                        type='submit'
                        variant='primary'
                        size='lg'
                        disabled={buttonSpinner || isSubmitting}>
                        Submit Now
                      </Button>
                    </Col>
                  </Row>
                </div>
              )}
              <Form.Group className='d-none' style={{ height: 0, opacity: 0 }}>
                <Form.Label className='text-light-gray'>Report Content</Form.Label>
                <Form.Control as='textarea' rows={0} name='report_content' id='report_content' value={values.report_content} isInvalid={Boolean(touched.report_content && errors.report_content)} onBlur={handleBlur} spellCheck={false} onChange={handleChange} />
                {!!touched.report_content && <Form.Control.Feedback type='invalid'>{errors.report_content}</Form.Control.Feedback>}
              </Form.Group>
              <div style={{ textAlign: 'right' }}>
                <Button variant='outline-secondary' size='lg' className='mt-3 d-none' onClick={() => closeModel(false)} style={{ marginRight: '1rem' }}>
                  Back
                </Button>
                <Button variant='outline-primary' size='lg' type='submit' className='mt-3 d-none' disabled={isSubmitting}>
                  Upload
                </Button>
              </div>
            </Form>
          );
        }}
      </Formik>
      <Modal show={showGetReportModal} onHide={() => setShowGetReportModal(false)} centered size='md' backdrop='static' keyboard={false}>
        <Modal.Body>
          <h2>{reportModalBody}</h2>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => closeReportModal()}>
            Close
          </Button>
          <Button variant='primary' onClick={() => handleReportSubmit()}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default ReportUpload;
